export interface IMFunctionalCard {
  bgUrl: string;
  name: string;
  desc: string;
  bgTitle: string;
  bgIntro: string;
  iconType: ECardType;
}

export enum ECardType {
  configuration = 'configuration',
  application = 'application'
}
